import { HStack, Spinner } from '@chakra-ui/react';
import { useEffect } from 'react';

export const OidcLoginPage = () => {
  useEffect(() => {
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: import.meta.env.VITE_SAP_CX_OIDC_CLIENT_ID,
      scope: 'openid daw.spectrum',
      redirect_uri: import.meta.env.VITE_SAP_CX_OIDC_CALLBACK_URL,
    });

    window.location.replace(
      `${import.meta.env.VITE_SAP_CX_OIDC_URL}/${import.meta.env.VITE_SAP_CX_OIDC_API_KEY}/authorize?${params.toString()}`,
    );
  }, []);

  return (
    <HStack alignItems='center' justifyContent='center' w='full' h='full'>
      <Spinner size='xl' />
    </HStack>
  );
};
